import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'discover-paging',
  templateUrl: './discover-paging.component.html',
  styleUrls: ['./discover-paging.component.scss'],
  standalone: true,
})
export class DiscoverPagingComponent {
  @Input() public size: number;
  @Input() public itemsPerSlide: number;

  @Output() public slideChange = new EventEmitter<number>();

  public currentSlide = 0;
  public get totalSlides() {
    return Math.ceil(this.size / this.itemsPerSlide);
  }

  public navigateTo(slide: number) {
    if (slide <= 0) {
      slide = 0;
    }
    if (slide >= this.totalSlides) {
      slide = this.totalSlides - 1;
    }
    this.currentSlide = slide;
    this.slideChange.emit(slide + 1);
  }
}
